<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-6 mb-2 mt-2"
            type="text"
            :value="form.code"
            :disabled="!formEditable"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-6 mb-2 mt-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :validator="$v.form.sections"
            :external-errors="errors['sections']"
            :label-form="'Sections' | translate"
            class-form="col-12 mb-2"
            labelColsSm="1"
            labelColsLg="1"
            label-search="name"
            :is-required="false"
            :disabled="!formEditable"
            :value="sectionsMulti"
            :options="sectionOptions"
            :placeholder="$t('Select one or more sections')"
            :min-length="0"
            @select="onSelectSection"
            @remove="onRemoveSection"
            @clear="onClearSections"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TEAM_ROLE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'TeamRoleEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Team role',
      rolePerm: ['account_teamrole_retrieve'],
      editRolePerm: ['account_teamrole_update'],
      sectionOptions: []
    }
  },
  computed: {
    ...mapGetters({
      ...TEAM_ROLE_TYPES.GENERIC.account.teamrole.DETAIL.GETTERS
    }),
    sectionsMulti () {
      const codes = Array.isArray(this.form.sections) ? this.form.sections : []
      return codes.map((code) => {
        const opt = this.sectionOptions.find((o) => o.id === code)
        return { id: code, name: opt ? opt.name : code }
      })
    }
  },
  components: { },
  methods: {
    ...mapActions({
      ...TEAM_ROLE_TYPES.GENERIC.account.teamrole.DETAIL.ACTIONS
    }),
    initFields () {
      this.getSections().then((sections) => {
        this.$set(this, 'sectionOptions', (sections || []).map((s) => ({ id: s.code, name: s.label })))
      })
    },
    onSelectSection (item) {
      const current = (Array.isArray(this.form.sections) ? this.form.sections : []).slice()
      if (!current.includes(item.id)) current.push(item.id)
      this.$set(this.form, 'sections', current)
    },
    onRemoveSection (item) {
      const current = Array.isArray(this.form.sections) ? this.form.sections : []
      this.$set(this.form, 'sections', current.filter((code) => code !== item.id))
    },
    onClearSections () {
      this.$set(this.form, 'sections', [])
    },
    setForm () {
      const form = Object.assign({}, this.detail)
      this.$set(this, 'form', form)
    },
    getFormData () {
      return Object.assign({}, this.form)
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      sections: {}
    }
  }
}
</script>
